import CertificatesAutocomplete from "../../ProductDetail/ProductCertificates";
import certificateList from "../../ProductDetail/ProductCertificates/CertificateList";
import { useTranslation } from "react-i18next";

import "../index.css";

export const ProductCertificatesAutocomplete = ({
  certificates = [],
  handleCertificatesChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className="variation-row-bg">
      <p className="product-detail-text" style={{ maxWidth: "fit-content" }}>
        {t("LIST_CERTIFICATIONS_PRODUCT")}
      </p>
      {
        <CertificatesAutocomplete
          editProduct={true}
          certificateList={certificateList}
          value={certificates}
          onChange={handleCertificatesChange}
        />
      }
    </div>
  );
};
